import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
import SoFormContainer from '../../components/layout/SoFormContainer';
import SoFormStopSummary from './SoFormStopSummary';
import SoFormPriceBreakdownSummary from './SoFormPriceBreakdownSummary';

const SoFormStepConfirmationBody = ({ className }) => {
  return (
    <div className={className}>
      <SoFormContainer>
        <SoFormStopSummary />
        <SoFormPriceBreakdownSummary />
      </SoFormContainer>
    </div>
  );
};

SoFormStepConfirmationBody.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormStepConfirmationBody)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 0px;
  width: 100%;
  ${SoFormContainer} {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 0px;
    gap: 16px;
    padding: 0;
  }
  flex-grow: 1;
`;
